import { requireDashboardOrigin } from "@api/auth/dashboardOriginGuard"
import { serverRouteConfig } from "@lib/serverRouteConfig"
import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"

const callbackInputSchema = z.object({
  code: z.string().min(1),
  codeVerifier: z.string().min(1),
})

export const Route = createFileRoute("/api/dashboard/auth/callback")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          callbackInputSchema.parse(await request.json())
          return Response.json({ error: "Google sign-in is not enabled." }, { status: 401 })
        },
      },
    },
  })
)
